/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TJoin, TNonEmptyArray, TRole, TRoleClaim, TTenant, TUser, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_RoleClaim, CommandResult_Void } from "../../helpers/types.graphql";
import { CommandResult } from "../fragment.graphql";

export type TGlobal = TRoleClaim
  | TJoin<"tenant", TTenant>
  | TJoin<"role", TRole>
  | TJoin<"claim", TClaim>

type TRoleClaimCreateFunctions = { create: CommandResult_RoleClaim };
export type TRoleClaimCreateMutations = { roleClaim: TRoleClaimCreateFunctions };
export const roleClaimCreate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation roleClaimCreate($roleClaim: RoleClaimCreateInputType!) {
    roleClaim {
      create(roleClaim: $roleClaim) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_RoleClaim")}
`;

type TRoleClaimUpdateFunctions = { update: CommandResult_RoleClaim };
export type TRoleClaimUpdateMutations = { roleClaim: TRoleClaimUpdateFunctions };
export const roleClaimUpdate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation roleClaimUpdate($roleClaim: RoleClaimUpdateInputType!) {
    roleClaim {
      update(roleClaim: $roleClaim) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_RoleClaim")}
`;

type TRoleClaimDeleteFunctions = { delete: CommandResult_RoleClaim };
export type TRoleClaimDeleteMutations = { roleClaim: TRoleClaimDeleteFunctions };
export const roleClaimDelete = () => gql`
  mutation roleClaimDelete($id: Guid!, $permanent: Boolean) {
    roleClaim {
      delete(id: $id, permanent: $permanent) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

type TSaveRoleClaimsFunctions = { saveRoleClaims: CommandResult_Void };
export type TSaveRoleClaimsMutations = { roleClaim: TSaveRoleClaimsFunctions };
export const saveRoleClaims = () => gql`
  mutation saveRoleClaims($saveRoleClaimsInput: SaveRoleClaimsInput!) {
    roleClaim {
      saveRoleClaims (saveRoleClaimsInput: $saveRoleClaimsInput) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
